import React from 'react';
import { Modal } from 'antd';
import styles from './DeleteModal.module.scss';

interface DeleteModalProps {
  visible: boolean;
  onConfirm: () => Promise<void>;
  onCancel: () => void;
  loading: boolean;
  selectedItems?: Set<number>;
  selectedItemsDetails?: Array<{ id: number; name: string; entryType: string; status?: string; share?: any[]; thumbnail?: any }>;
  fileDetail?: any;
  currentEntry?: any;
}

const DeleteModal: React.FC<DeleteModalProps> = ({
  visible,
  onConfirm,
  onCancel,
  loading,
  selectedItems,
  selectedItemsDetails,
  fileDetail,
  currentEntry
}) => {
  const getModalTitle = () => {
    if (selectedItems && selectedItems.size > 0) {
      // Seçili öğelerin entryType'ı aynı varsayılıyor
      let typeLabel = 'Item';
      if (selectedItemsDetails && selectedItemsDetails.length > 0) {
        const entryType = (selectedItemsDetails[0].entryType || '').toString();
        if (entryType === 'File') typeLabel = 'File';
        else if (entryType === 'Folder') typeLabel = 'Folder';
        else if (entryType === 'Project') typeLabel = 'Project';
        else if (entryType === 'Version') typeLabel = 'Version';
        else typeLabel = entryType || 'Item';
      }
      const plural = selectedItems.size > 1 ? 's' : '';
      return `Delete Selected ${typeLabel}${plural}`;
    }
    if (fileDetail) {
      return window.location.hash ? "Delete Version" : "Delete File";
    }
    if (currentEntry) {
      return `Delete ${currentEntry.name} ${currentEntry.entryType === 'File' ? 'File' : 'Folder'}`;
    }
    return "Delete";
  };

  const getModalContent = () => {
    if (selectedItems && selectedItems.size > 0) {
      if (selectedItemsDetails && selectedItemsDetails.length > 0) {
        return (
          <>
            Are you sure you want to delete the following items?
            <ul className={styles.itemList}>
              {selectedItemsDetails.map((item) => (
                <li key={item.id} className={styles.listItem}>
                  <strong>{item.name}</strong> 
                </li>
              ))}
            </ul>
          </>
        );
      }
      return `Are you sure you want to delete the selected ${selectedItems.size} items?`;
    }

    if (fileDetail && window.location.hash) {
      return (
        <>
          Are you sure you want to delete the <strong>{window.location.hash.substring(1)}</strong> version of the{' '}
          <strong>{fileDetail?.name}</strong> file?
        </>
      );
    }

    if (fileDetail) {
      return (
        <>
          Are you sure you want to delete the <strong>{fileDetail?.name}</strong> file?
        </>
      );
    }

    if (currentEntry) {
      return (
        <>
          Are you sure you want to delete the <strong>{currentEntry.name}</strong> {currentEntry.entryType === 'File' ? 'file' : 'folder'}?
        </>
      );
    }

    return "Are you sure you want to delete this item?";
  };

  const getWarningText = () => {
    if (selectedItems && selectedItems.size > 0) {
      let typeLabel = 'item';
      if (selectedItemsDetails && selectedItemsDetails.length > 0) {
        const entryType = (selectedItemsDetails[0].entryType || '').toString();
        if (entryType === 'File') typeLabel = 'file';
        else if (entryType === 'Folder') typeLabel = 'folder';
        else if (entryType === 'Project') typeLabel = 'project';
        else if (entryType === 'Version') typeLabel = 'version';
        else typeLabel = entryType ? entryType.toLowerCase() : 'item';
      }
      const plural = selectedItems.size > 1 ? 's' : '';
      return `This action cannot be undone and the selected ${typeLabel}${plural} will be permanently deleted.`;
    }

    if (fileDetail && window.location.hash) {
      return "This action cannot be undone and the selected version will be permanently deleted.";
    }

    if (fileDetail) {
      return "This action cannot be undone and all versions, comments and data will be permanently deleted.";
    }

    if (currentEntry) {
      return currentEntry.entryType === 'File' 
        ? "This action cannot be undone and the file will be permanently deleted."
        : "This action cannot be undone and all files and folders within this folder will be permanently deleted.";
    }

    return "This action cannot be undone and the item will be permanently deleted.";
  };

  return (
    <Modal
      title={getModalTitle()}
      open={visible}
      onOk={onConfirm}
      onCancel={onCancel}
      confirmLoading={loading}
      okText="Delete"
      cancelText="Cancel"
      okButtonProps={{ 
        className: styles.deleteButton
      }}
      className={styles.deleteModal}
    >
      <div className={styles.content}>
        <p className={styles.mainText}>
          {getModalContent()}
        </p>
        <p className={styles.warningText}>
          {getWarningText()}
        </p>
      </div>
    </Modal>
  );
};

export default DeleteModal; 